import moment from 'moment'

export default {
  methods: {
    toMonthYear (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('MMM YYYY')
    },
    toDayMonthYearTime (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY [at] HH:mm')
    },
    toYearYearMonthDay (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    calcLast12MonthsDate () {
      let dateTo = moment()
      let dateFrom = moment()

      dateTo.subtract(1, 'months').endOf('month')
      dateFrom.subtract(12, 'months').date(1)

      return {startDate: this.toYearYearMonthDay(dateFrom), endDate: this.toYearYearMonthDay(dateTo)}
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/moment.js